import React, { ReactElement } from "react";
import {
  ToolCallBlock,
  WiseOwlElementIds,
} from "@twiliointernal/e2-commons-shared-definitions";
import { Box } from "@twilio-paste/core/box";
import { Heading } from "@twilio-paste/core/heading";
import {
  Modal,
  ModalHeader,
  ModalHeading,
  ModalBody,
} from "@twilio-paste/core/modal";
import { TabList, Tab, TabPanel } from "@twilio-paste/core/reakit-library";
import { Tabs, TabPanels } from "@twilio-paste/core/tabs";

interface ToolCallBlockRendererProps {
  block: ToolCallBlock;
}

const formatText = (text: string) => {
  try {
    return JSON.stringify(JSON.parse(text), null, 4);
  } catch (err) {
    return text;
  }
};

const ToolCallRenderer = ({
  block,
}: ToolCallBlockRendererProps): ReactElement => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const modalHeadingID = block.values.name;
  const selectedId = `${block.values.name}-selected`;

  return (
    <>
      <Box display="flex" element={WiseOwlElementIds.WISE_OWL_TOOL_CALL_BLOCK}>
        <Box
          backgroundColor="colorBackgroundBody"
          padding="space40"
          borderColor="colorBorderDecorative10Weaker"
          borderWidth="borderWidth10"
          borderStyle="solid"
          borderRadius="borderRadius30"
          cursor="pointer"
          onClick={handleOpen}
        >
          <Heading as="h2" variant="heading30" marginBottom="space0">
            <code>Performed Action: {block.values.name}</code>
          </Heading>
        </Box>
      </Box>
      <Modal
        ariaLabelledby={modalHeadingID}
        isOpen={isOpen}
        onDismiss={handleClose}
        size="wide"
      >
        <ModalHeader>
          <ModalHeading as="h3" id={modalHeadingID}>
            Performed Action: {block.values.name}
          </ModalHeading>
        </ModalHeader>
        <ModalBody>
          <Tabs selectedId={selectedId} baseId="horizontal-tabs-example">
            <TabList aria-label="Horizontal product tabs">
              <Tab id={selectedId}>Input</Tab>
              <Tab>Output</Tab>
              <Tab>Formatted Output</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <Box height="700px" whiteSpace="pre">
                  <code>{formatText(block.values.input)}</code>
                </Box>
              </TabPanel>
              <TabPanel>
                <Box height="700px" whiteSpace="pre">
                  <code>{formatText(block.values.output)}</code>
                </Box>
              </TabPanel>
              <TabPanel>
                <Box height="700px" whiteSpace="pre">
                  <code>{formatText(block.values.formattedOutput)}</code>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ToolCallRenderer;
